import { Base } from '@studiometa/js-toolkit';

/**
 * Homepage class.
 */
export default class MenuItem extends Base {
  /**
   * Class cofnig
   * @type {Object}
   */
  static config = {
    name: 'MenuItem',
    refs: ['panel', 'closer', 'opener'],
  };

  /**
   * onOpenerClick
   * @param  {Object} e
   * @returns {void}
   */
  onOpenerClick(e) {
    e.preventDefault();
    this.$refs.panel.classList.toggle('translate-x-full');
  }

  /**
   * onCloserClick
   * @param  {Object} e
   * @returns {void}
   */
  onCloserClick(e) {
    e.preventDefault();
    this.$refs.panel.classList.toggle('translate-x-full');
  }
}
